var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-webpage"},[_c('img',{attrs:{"src":(_vm.assetUrl + "/" + (_vm.screenshot.name || _vm.screenshot.assetPath))}})])}
var staticRenderFns = []

export { render, staticRenderFns }